module.exports = __webpack_public_path__ + "static/add-customer-field-pay-by-po-afa31bbb21ab9260e03e33917cc16680.png";